exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".button-58306{height:initial;padding:8px 16px;border-radius:8px !important}", ""]);

// Exports
exports.locals = {
	"button": "button-58306"
};